// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav-link {
  color: #b42949 !important;
  font-weight: 700;
  font-size: 0.9rem !important;
}

.navbar {
  padding: 0;
  font-family: 'Open Sans Condensed', sans-serif;
}
.dropdown-menu {
  z-index: 2000 !important; /* should be large than sidemenu zindex */
}
.dropdown-toggle::after {
  display: inline-block;
  width: 0.5em;
  height: 0.5em;
  margin: -0.3em 0 0 0.5em;
  vertical-align: middle;
  content: '';
  border: 0.3em solid;
  border-width: 0 0.15em 0.15em 0;
  /* transform: rotateZ(45deg); */
}

@media (min-width: 992px) {
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
  }
}

@media (min-width: 992px) {
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (max-width: 992px) {
  .navbar-light .navbar-toggler {
    margin-left: 15px;
  }
  .padrl15.navbar.navbar-expand-lg.navbar-light {
    padding: 0px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/navbar/Navbar.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,8CAA8C;AAChD;AACA;EACE,wBAAwB,EAAE,yCAAyC;AACrE;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,wBAAwB;EACxB,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE;IACE,mBAAmB;IACnB,WAAW;IACX,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;AACF","sourcesContent":[".nav-link {\n  color: #b42949 !important;\n  font-weight: 700;\n  font-size: 0.9rem !important;\n}\n\n.navbar {\n  padding: 0;\n  font-family: 'Open Sans Condensed', sans-serif;\n}\n.dropdown-menu {\n  z-index: 2000 !important; /* should be large than sidemenu zindex */\n}\n.dropdown-toggle::after {\n  display: inline-block;\n  width: 0.5em;\n  height: 0.5em;\n  margin: -0.3em 0 0 0.5em;\n  vertical-align: middle;\n  content: '';\n  border: 0.3em solid;\n  border-width: 0 0.15em 0.15em 0;\n  /* transform: rotateZ(45deg); */\n}\n\n@media (min-width: 992px) {\n  .navbar-expand-lg .navbar-nav {\n    flex-direction: row;\n    width: 100%;\n    justify-content: space-between;\n  }\n}\n\n@media (min-width: 992px) {\n  .navbar-expand-lg .navbar-nav .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n@media (max-width: 992px) {\n  .navbar-light .navbar-toggler {\n    margin-left: 15px;\n  }\n  .padrl15.navbar.navbar-expand-lg.navbar-light {\n    padding: 0px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
